import { render } from "./NostalgicMessage.vue?vue&type=template&id=e237e804&scoped=true"
import script from "./NostalgicMessage.vue?vue&type=script&lang=js"
export * from "./NostalgicMessage.vue?vue&type=script&lang=js"

import "./NostalgicMessage.vue?vue&type=style&index=0&id=e237e804&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e237e804"]])

export default __exports__